import { Link } from "react-router-dom";
import classNames from "classnames";

import Wrapper from "./Wrapper";

export interface BreadcrumbItem {
    title: string;
    link?: string; // No link: shown as plain text (use it for the current page)
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    wrapper?: boolean; // Wrap in the page-width container (turn off inside a column)
}

const Breadcrumb = ({ items, wrapper = true }: BreadcrumbProps) => {
    const list = (
        <ol className="flex flex-wrap items-center list-none">
            {items.map((item, index) => {
                const isLast = index === items.length - 1;
                // "#" was used before as "not clickable": treat it the same as no link
                const isLink = !!item.link && item.link !== "#" && !isLast;

                return (
                    <li key={`${item.title}-${index}`} className="flex items-center">
                        {index > 0 && (
                            <span className="mx-2" aria-hidden="true">
                                /
                            </span>
                        )}

                        {isLink ? (
                            <Link to={item.link as string} className="text-gray-700 underline">
                                {item.title}
                            </Link>
                        ) : (
                            // The last item is the current page: screen readers announce it as such
                            <span aria-current={isLast ? "page" : undefined}>{item.title}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );

    return (
        <nav aria-label="breadcrumb" className={classNames("py-2 text-gray-500 mb-2")}>
            {wrapper ? <Wrapper>{list}</Wrapper> : list}
        </nav>
    );
};

export default Breadcrumb;